import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Formik } from 'formik'
import moment from 'moment'
import uuidV4 from 'uuid/v4'
import RenderReportForm from './RenderCreateReportForm/RenderCreateReportForm'
import { dateFormat } from '../../../../componentIsoMophic/ScrumBoard/FieldFormats'
import scrumBoardActions from '../../../../redux/scrumBoard/actions'
import { CreateReportWrapper } from './ReportCreateOrUpdate.style'
import OrgAction from '../../../../redux/organization/actions'
import { notification } from 'antd'
import * as Yup from 'yup'

const initialValues = {
    id: '',
    title: '',
    description: '',
    labels: [],
    assignees: [],
    attachments: [],
    comments: [],
    todos: [],
    column_id: '',
    editing: false,
    created_at: moment(Date.now()),
    updated_at: moment(Date.now()),
    due_date: moment(Date.now()),
    selectOptions: ['success', 'error', 'processing', 'warning', 'default'],
    selectAssignees: ['Mark', 'Bob', 'Anthony'],
}

const ReportForm = props => {
    useEffect(() => {
        return () => {
            console.log('reset data update task')
            props.deleteListTagUpdate()
            props.deleteListOrgQuery()
            if (props.initials) {
                props.getDetailTaskById(props.initials.IdOfTask)
            }
        }
    }, [props.deleteListOrgQuery])
    console.log('props.initials report', props.initials)

    const initials = {
        ...initialValues,
        ...props.initials,
        due_date: moment(
            props.initials && props.initials.due_date
                ? props.initials.due_date * 1000
                : Date.now()
        ),
        updated_at: moment(Date.now()),
    }
    console.log('props hashtag', props.listUpdateHashTag)
    const SignupSchema = Yup.object().shape({
        title: Yup.string()
            .trim()
            .min(0, 'Không được để trống')
            .required('Không được để trống'),
        description: Yup.string()
            .notOneOf(['<p><br></p>'], 'Không được để trống ')
            .min(0, 'Không được để trống')
            .required('Không được để trống'),
    })
    const handleSubmit = formProps => {
        console.log('formProps', formProps)
        if (!props.initials) {
            const listMedia = []
            props.ListCurrentMedia.map(media => {
                listMedia.push(media.media_id)
            })

            const listObject = []
            props.ListCurrentObject.map(data => {
                listObject.push(data.object_id)
            })
            const listEventId = []
            props.ListCurrentEvent.map(event => {
                listEventId.push(event.event_id)
            })
            const dataCreateNew = {
                hashtag: formProps.labels.concat(props.listUpdateHashTag),
                event: listEventId,
                media: listMedia,
                object: listObject,
                receiver_uid: [],
                task_id: props.idOfBoard >> 0,
                organ_receive: 0,
                content: formProps.description,
                title: formProps.title,
            }
            props.createNewReport(dataCreateNew)
            console.log('formProps', dataCreateNew)
        } else {
            if (props.initials.canEdit) {
                const listMedia = []
                props.ListCurrentMedia.map(media => {
                    listMedia.push(media.media_id)
                })

                const listObject = []
                props.ListCurrentObject.map(data => {
                    listObject.push(data.object_id)
                })
                const listEventId = []
                props.ListCurrentEvent.map(event => {
                    listEventId.push(event.event_id)
                })
                const dataUpdate = {
                    hashtag: formProps.labels.concat(props.listUpdateHashTag),
                    event: listEventId,
                    media: listMedia,
                    object: listObject,
                    content: formProps.description,
                    title: formProps.title,
                }
                props.updateReportReWork(props.initials.id, dataUpdate)
                console.log('formProps update', dataUpdate)
            }
        }
        props.closeDrawer()
    }

    return (
        <CreateReportWrapper>
            <Formik
                initialValues={initials}
                onSubmit={handleSubmit}
                validationSchema={SignupSchema}
                render={formikProps => (
                    <RenderReportForm
                        {...formikProps}
                        onCancel={props.closeDrawer}
                        onDelete={() => {
                            // props.deleteTask({
                            //     taskId: props.initials.id,
                            //     column_id: props.columnId,
                            // })
                            props.closeDrawer()
                        }}
                        onEditCancel={() => {
                            // props.cancelEditTask(props.initials)
                            props.openDrawer({
                                drawerType: 'CARD_DETAILS',
                                drawerProps: {
                                    task: { ...props.initials },
                                    columnId: props.columnId,
                                },
                            })
                        }}
                    />
                )}
            />
        </CreateReportWrapper>
    )
}
export default connect(
    (state, ownProps) => {
        return {
            listOrgUpdate: state.organization.listOrgUpdate,
            listUpdateHashTag: state.scrumBoard.listUpdateHashTag,
            ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
            ListCurrentObject: state.scrumBoard.ListCurrentObject,
            ListCurrentEvent: state.scrumBoard.ListCurrentEvent,
        }
    },
    {
        ...scrumBoardActions,
        ...OrgAction.action,
    }
)(ReportForm)
